import { proxiedUrlFor } from "./media-url-utils";

/**
 * Constructs an absolute /assets/{uuid} URL from an asset object
 * with fallback to original URL when UUID is unavailable.
 *
 * @param {Object} asset - Asset object containing uuid and url fields
 * @param {Object} configs - Configuration object with PERSISTENCE_API_URL
 * @returns {string} Proxied absolute URL or fallback URL
 */
export default function buildAssetUrl(asset, configs) {
  // Check if asset.uuid exists and is a non-empty string
  if (asset.uuid && typeof asset.uuid === "string" && asset.uuid.trim() !== "") {
    // Construct absolute /assets/{uuid} URL
    const assetUrl = `${configs.PERSISTENCE_API_URL}/assets/${asset.uuid}`;
    // Apply proxying for CORS compliance
    return proxiedUrlFor(assetUrl);
  }

  // Fallback to original URL if UUID is missing or invalid
  return asset.url;
}
